import React from "react";

interface ConditionalEasyPlusRendererProps<T> {
    easyPlusEnabled: boolean;
    data: T[];
    renderWhenDisabled: () => React.ReactNode;
    renderWhenHasData: (data: T[]) => React.ReactNode;
    renderWhenNoData: () => React.ReactNode;
}

export const ConditionalEasyPlusRenderer = <T,>({
    easyPlusEnabled,
    data,
    renderWhenDisabled,
    renderWhenHasData,
    renderWhenNoData,
}: ConditionalEasyPlusRendererProps<T>) => {
    if (!easyPlusEnabled) {
        return <>{renderWhenDisabled()}</>;
    }

    if (data.length > 0) {
        return <>{renderWhenHasData(data)}</>;
    }

    return <>{renderWhenNoData()}</>;
};